import API from "api/API"
import {ApiDeleteResult} from "app/Interface/Api/ApiResult"
import {ApiSystemLayoutTabGridItemPatch, ApiSystemLayoutTabGridItemPut} from "app/Interface/Api/System/ApiSystemLayout"
import Logger from "logger/logger"
import {useEffect} from "react"
import {systemLayoutStore} from "store/system/layout/system.layout.store"

function ApiSystemLayoutGridItemService(caller: string) {

  const url = '/system/grid/item'

  useEffect(() => {
    Logger(`Service.API.System.Layout.GridItem.init.${caller}`)
    return () => {
      Logger(`Service.API.System.Layout.GridItem.unloading.${caller}`)
    }
  }, [])

  const patchGridItems = async (gridItems: ApiSystemLayoutTabGridItemPatch): Promise<void> => {
    await API.patch<void, ApiSystemLayoutTabGridItemPatch>(url, gridItems)
  }

  const putGridItem = async (data: ApiSystemLayoutTabGridItemPut): Promise<void> => {
    await API.put<void, ApiSystemLayoutTabGridItemPut>(url, data)
  }

  const deleteGridItem: ApiDeleteResult = async (id): Promise<void> => {
    Logger(`Service.API.System.Layout.GridItem.${caller}`, 'deleteGridItem')
    systemLayoutStore.ui.update(state => {
      state.isDeleting = true
    })
    await API.delete(`${url}/${id}`)
    systemLayoutStore.ui.update(state => {
      state.isDeleting = false
    })
  }

  return {
    patchGridItems,
    putGridItem,
    deleteGridItem
  }

}

export default ApiSystemLayoutGridItemService
